app.service('loginModal', function (modal, loading, validate, agreementsSubmit, ajaxOrder, front, log,
	passwordInvalid, captchaService, simpleToastr, cookie, orderConfig) {
	var $loginForm, $registerForm;
	var loginSuccess;
	var config, type, callbackSuccess;
	var savedOptions;

	function addRegistrationCaptcha() {
		let $captcha = $registerForm.find('[data-toggle="captcha"]');
		if ($captcha.length) {
			captchaService.load($captcha.attr('id'), $captcha.data('place'));
		}
	}
	function addLoginCaptcha() {
		let $captcha = $loginForm.find('[data-toggle="captcha"]');
		let username = $loginForm.find('[name="j_username"]').val();
		if ($captcha.length) {
			captchaService.load($captcha.attr('id'), $captcha.data('place'), username);
		}
	}

	function registrationFormSend() {
		var data = $registerForm.find('input').serializeArray();
		if (config && config.guestData) {
			data.push({
				name: 'email',
				value: config.guestData.email
			});
			data.push({
				name: 'firstname',
				value: config.guestData.firstName
			});
			data.push({
				name: 'surname',
				value: config.guestData.surName
			});
		}
		const token = $registerForm.find('[data-toggle="captcha"] .g-recaptcha-response').val();
		addRecaptchaToken(token, data);
		var $errorText = $registerForm.find('#registration-error');
		var url = '/layer-order-registration.ltr';
		loading.start();
		$.ajax({
			url: url,
			type: 'POST',
			data: data,
			success: function (json) {
				loading.stop();
				if (json.loginFailed && json.errorMessage !== '') {
					$errorText.html(json.errorMessage);
					addRegistrationCaptcha();
				}
				if (json.loginSuccessful) {
					if (testAB.getVar('ajax-order') === 'B' && front.getParam('ajaxOrder')) {
						registrationSuccessModal();
					} else {
						cookie.set('registration-success', true, { path: '/', expires: 1 / 24 / 60 / 2 });
					}
					reload();
				}
			},
			error: function () {
				loading.stop();
				$errorText.text('Błąd komunikacji. Prosimy spróbować raz jeszcze!');
			}
		});
	}
	function reload() {
		modal.close();
		if(savedOptions.callbackAfterSuccess){
			savedOptions.callbackAfterSuccess();
		} else {
			if (type != 'login-voucher') {
				if (testAB.getVar('ajax-order') === 'B' && front.getParam('ajaxOrder')) {
					ajaxOrder.reload();
				} else {
					loading.reload();
				}
			}
		}

	}
	function addRecaptchaToken(token, data) {
		if (token) {
			data.push({
				name: 'g-recaptcha-response',
				value: token
			});
		}
	}
	function registrationFormSuccess() {
		$registerForm.find('input:checkbox').click(function () {
			$registerForm.validate().element($(this));
		});
		agreementsSubmit.init($registerForm, $registerForm.find('input[name=permissionToProcessingAccepted]'));

		validate.task('registrationLayer', function () {
			registrationFormSend();
		});

		passwordInvalid.init($('#password'), $('.password-invalid', $registerForm), $('#password', $registerForm).closest('.row'));
	}
	function loginFormSend() {
		var data = $loginForm.find('input').serializeArray();
		const token = $loginForm.find('[data-toggle="captcha"] .g-recaptcha-response').val();
		const idCaptcha = $loginForm.find('[data-toggle="captcha"]').attr('id');
		addRecaptchaToken(token, data);
		const $errorText = $loginForm.find('#login-error');
		loading.start();
		log.event({
			id:'login-voucher-send'
		});
		$.ajax({
			url: type === 'login-voucher' ? '/json_j_spring_security_check.ltr' : '/layer_order_j_spring_security_check.ltr',
			type: 'POST',
			data: data,
			success: function (json) {
				loading.stop();
				if (json.loginFailed && json.errorMessage !== '') {
					$errorText.html(json.errorMessage);
					captchaService.reset(idCaptcha);
					addLoginCaptcha();
				} else if (json.loginSuccessful) {
					if (type == 'login-voucher') {
						log.event({
							id:'login-voucher-success'
						});
						loginSuccess = true;
						modal.close();
						if(callbackSuccess){
							callbackSuccess();
						}
					}
					reload();
				}
			},
			error: function () {
				loading.stop();
				$errorText.text('Błąd komunikacji. Prosimy spróbować raz jeszcze!');
			}
		});
	}

	function loginFormSuccess() {
		$loginForm.find('button').on('click', function(){
			log.event({
				id:'login-voucher-submit',
			});
		});
		validate.task('loginLayer', function () {
			loginFormSend();
		});
	}
	let isBusy = false;
	function load(options) {
		if(!isBusy){
			isBusy = true;
			loading.start();
			config = orderConfig.getData();
			loginSuccess = false;
			savedOptions = options;
			$.ajax({
				url: '/layer-order-registration.ltr',
				data: {
					type: options.type
				},
				success: function (html) {
					loadLayerSuccess(options, html);
				},
				error: function () {
					loading.stop();
					isBusy = false;
					modal.alert('Wystąpił błąd ładowania warstwy ' + (options.type == 'login' ? 'logowania' : 'rejestracji') + '. Prosimy spróbować później');
				}
			});
		}
	}

	function init(){

	}
	function registrationSuccessModal() {
		simpleToastr.generate('<h2>Twoje konto zostało założone</h2>');
	}

	function loadLayerSuccess(options, html) {
		loading.stop();
		type = options.type;
		callbackSuccess = options.callbackSuccess;
		modal.generate({
			content: html,
			id: 'login-modal',
			modifier: 'remodal-full-width ' + options.type,
			callbackClose: function () {
       			if (type == 'login-voucher' && !loginSuccess) {
      				log.event({
						id:'login-voucher-close',
					});
 				}
			},
			callbackOpen: function () {
				isBusy = false;
				if (type == 'login-guest') {
					$loginForm = $('#login-form');
					if (config.guestData) {
						$('#login-username', $loginForm).val(config.guestData.email);
						$('.client-payment', $loginForm).text(options.paymentName);
					}
					loginFormSuccess();
					addLoginCaptcha();
				} else if (type == 'login-voucher') {
					$loginForm = $('#login-form');
					loginFormSuccess();
					addLoginCaptcha();
					log.event({
						id:'login-voucher-open',
						f04: options.voucherCode
					});
				} else {
					$registerForm = $('#registration-form');
					$('.client-payment', $registerForm).text(options.paymentName);
					$('#client-email').text(config.guestData.email);
					registrationFormSuccess();
					addRegistrationCaptcha();
				}
			}
		});
	}

	return {
		load,
		init
	};
});
